<template>
  <div class="c-card addresses">
    <div class="c-card--title">
      <h3>{{$t('profile.addresses.title')}}</h3>
    </div>
    <div class="c-card--content c-loading" v-if="loading">
      <div class="loader">
        <loader/>
      </div>
    </div>
    <div class="c-card--content" v-if="!loading">
      <div class="address-container" v-for="(address, index) in addresses" :item="address" :index="index"
           :key="address.id" :class="{'main-address': address.is_main}">
        <div class="address-flex-left">
          <div class="address-main" v-if="address.society_name">{{address.society_name}}</div>
          <div class="address-main" v-else>{{address.description}}</div>
          <div class="address-line1">{{address.address}}</div>
          <div class="address-additional" v-if="address.additional">{{address.additional}}</div>
          <div class="address-zone">{{address.zip}}, {{address.city}}, {{address.country.alpha2}}</div>
        </div>
        <div class="address-actions">
          <div class="address-texts" v-if="address.is_main">
            <span>{{$t('profile.addresses.warning')}}</span>
          </div>
          <div class="btn-container">
            <button class="btn btn-secondary btn-icon" @click="openModal(address.id)"><i class="las la-edit"></i></button>
            <button class="btn btn-secondary btn-icon" v-if="!address.is_main" @click="deleteAddress(address.id)"><i class="las la-trash"></i></button>
            <button class="btn btn-secondary btn-icon" v-if="!address.is_main" @click="setFavorite(address.id)"><i class="las la-bookmark"></i></button>
          </div>
        </div>
      </div>
    </div>
    <div class="c-card--footer" v-if="!loading">
      <button class="colored-btn red-btn" @click="openModal()">
        <i class="las la-plus"></i> {{$t('profile.addresses.btn')}}
      </button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import TextInput from '../../../components/text-input';
import CheckboxInput from '../../../components/checkbox-input';
import SelectInput from '../../../components/select-input';
import Loader from '../../../components/loader.component';

export default {
  name: 'addresses',
  components: { Loader, SelectInput, CheckboxInput, TextInput },
  computed: mapState({
    loading: s => s.clientAddresses.loading || s.countries.loading,
    addresses: s => s.clientAddresses.addresses.sort((a, b) => (a.is_main < b.is_main ? 1 : -1)),
  }),
  methods: {
    async openModal(id) {
      await this.$store.commit('addressesModal/SET_ADDRESS_ID', id);
      window.dispatchEvent(new Event('app:addresses-modal.open'));
    },
    setFavorite(addressId) {
      this.$store.dispatch('clientAddresses/update', { address_id: addressId, is_main: true });
    },
    deleteAddress(addressId) {
      this.$store.dispatch('clientAddresses/delete', addressId);
    },
  },
  async mounted() {
    await this.$store.dispatch('clientAddresses/fetch');
    await this.$store.dispatch('countries/init');
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/client/part/addresses.vue